import { ConnectionStrategy } from './connection-strategy';
export class RequestStrategy extends ConnectionStrategy {
  constructor(options) {
    super(options);
    this.passHints = options.passHints;
  }

  generateListener() {
    const target = this.target;
    return (...args) => {
      let result;

      if (this._filter) {
        if (!this._filter(...args)) {
          return;
        }
      }

      if (typeof this._action === 'string') {
        result = target[this._action](args[0]);
      } else {
        result = this._action(...args);
      }

      if (this._catch && result && result.catch) {
        result = result.catch(e => {
          return this._catch(e, ...args);
        });
      }

      if (result && result.then) {
        let blocking = false;

        if (typeof this._blocking === 'function') {
          if (this._blocking(...args)) {
            blocking = true;
          }
        } else if (this._blocking) {
          blocking = true;
        }

        if (blocking) {
          if (this.passHints) {
            const hints = args[1];

            if (typeof hints === 'object') {
              return this.applyHint(hints, result);
            }
          }

          return result;
        }
      }
    };
  }

  async applyHint(hints, result) {
    return hints.data = await result;
  }

}